import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/a1_mover/banner.png';
import _imports_1 from '../../../assets/new/53.png';
import _imports_2 from '../../../assets/new/54.png';
import _imports_3 from '../../../assets/new/11.png';
import _imports_4 from '../../../assets/new/12.png';
import _imports_5 from '@/assets/hunan/banner.png';
import _imports_6 from '../../../assets/new/35.png';
import _imports_7 from '../../../assets/new/36.png';
import _imports_8 from '../../../assets/new/5.png';
import _imports_9 from '../../../assets/new/8.png';
import _imports_10 from '../../../assets/new/9.png';
import _imports_11 from '../../../assets/new/10.png';
import _imports_12 from '../../../assets/new/48.png';
const _withScopeId = n => (_pushScopeId("data-v-e3823ce2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "itemHead"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "同步阅读"), /*#__PURE__*/_createElementVNode("h4", null, "与你所在年级匹配的阅读资源")]), /*#__PURE__*/_createElementVNode("a", {
  href: "javascript: void(0)"
}, "全部")], -1));
const _hoisted_7 = {
  class: "media"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 1,
  src: _imports_1
};
const _hoisted_11 = {
  key: 2,
  src: _imports_2
};
const _hoisted_12 = {
  key: 0,
  class: "status"
};
const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = {
  class: "itemHead"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "扩展阅读"), /*#__PURE__*/_createElementVNode("h4", null, "带你读、陪你读、教你读")], -1));
const _hoisted_16 = {
  class: "media"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 1,
  src: _imports_1
};
const _hoisted_20 = {
  key: 2,
  src: _imports_2
};
const _hoisted_21 = {
  key: 0,
  class: "status"
};
const _hoisted_22 = {
  class: "banner"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_25 = [_hoisted_24];
const _hoisted_26 = {
  class: "item"
};
const _hoisted_27 = {
  class: "itemHead exam"
};
const _hoisted_28 = {
  class: "myExam"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "我的模拟考试：", -1));
const _hoisted_30 = {
  class: "filter"
};
const _hoisted_31 = {
  class: "selects"
};
const _hoisted_32 = {
  key: 0,
  src: _imports_6
};
const _hoisted_33 = {
  key: 1,
  src: _imports_7
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "注：每日仅限一次写作、翻译的AI评分", -1));
const _hoisted_35 = {
  class: "lists"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 0,
  class: "unfinish"
};
const _hoisted_38 = {
  key: 0,
  class: "record"
};
const _hoisted_39 = ["onClick", "onMouseenter", "onMouseleave"];
const _hoisted_40 = {
  key: 0,
  class: "pageTip"
};
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"itemHead\" data-v-e3823ce2><div data-v-e3823ce2><h3 data-v-e3823ce2>他们都在读</h3><h4 data-v-e3823ce2>同级热点主题文章</h4></div><a href=\"javascript: void(0)\" data-v-e3823ce2>全部</a></div><ul class=\"list\" data-v-e3823ce2><li data-v-e3823ce2><a href=\"javascript: void(0)\" data-v-e3823ce2><img src=\"" + _imports_8 + "\" data-v-e3823ce2><h3 data-v-e3823ce2>安妮日记</h3><span data-v-e3823ce2> 难度：<img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2></span></a></li><li data-v-e3823ce2><a href=\"javascript: void(0)\" data-v-e3823ce2><img src=\"" + _imports_8 + "\" data-v-e3823ce2><h3 data-v-e3823ce2>安妮日记</h3><span data-v-e3823ce2> 难度：<img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2></span></a></li><li data-v-e3823ce2><a href=\"javascript: void(0)\" data-v-e3823ce2><img src=\"" + _imports_8 + "\" data-v-e3823ce2><h3 data-v-e3823ce2>安妮日记</h3><span data-v-e3823ce2> 难度：<img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2></span></a></li><li data-v-e3823ce2><a href=\"javascript: void(0)\" data-v-e3823ce2><img src=\"" + _imports_8 + "\" data-v-e3823ce2><h3 data-v-e3823ce2>安妮日记</h3><span data-v-e3823ce2> 难度：<img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2></span></a></li><li data-v-e3823ce2><a href=\"javascript: void(0)\" data-v-e3823ce2><img src=\"" + _imports_8 + "\" data-v-e3823ce2><h3 data-v-e3823ce2>安妮日记</h3><span data-v-e3823ce2> 难度：<img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2></span></a></li><li data-v-e3823ce2><a href=\"javascript: void(0)\" data-v-e3823ce2><img src=\"" + _imports_8 + "\" data-v-e3823ce2><h3 data-v-e3823ce2>安妮日记</h3><span data-v-e3823ce2> 难度：<img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2><img src=\"" + _imports_3 + "\" data-v-e3823ce2></span></a></li></ul>", 2);
const _hoisted_43 = [_hoisted_41];
const _hoisted_44 = {
  key: 0,
  style: {
    "height": "6rem"
  }
};
const _hoisted_45 = {
  class: "footer"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10
}, null, -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h4", null, "This is the Article"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("这是你首次阅读这篇文章"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Una老师准备好了带你阅")]), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12
}), /*#__PURE__*/_createElementVNode("a", {
  href: "javascript: void(0)"
}, "不喜欢，换一篇")])], -1));
import { ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { getLocalPid } from "../../../libs/util";
import { useRouter } from "vue-router";
import { PaperTypeList, PaperList } from '../../../api/examAPI';
export default {
  __name: 'index_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const router = useRouter();
    const store = useStore();
    const pid = getLocalPid();
    const token = computed(() => store.state.token);
    const sign = computed(() => store.state.sign);
    const userId = computed(() => store.state.userId);
    const show = ref(false);
    const articleData = computed(() => store.state.articleData);
    onMounted(() => {
      if (!token.value) {
        getToken();
      } else {
        store.dispatch("getUserInfo", "article");
      }
      let title = localStorage.getItem("title");
      if (title) {
        document.title = title;
      }
      const obj = JSON.parse(window.localStorage.getItem('exam'));
      if (obj) {
        searchParams.grade = obj.value;
        gradeName.value = obj.name;
        getPaperList();
      }
      getPaperTypeList();
    });
    const navTo = id => {
      router.push({
        name: "article",
        query: {
          id,
          pid
        }
      });
    };
    const getToken = () => {
      store.commit("init");
    };
    const grades = ref(null);
    const list = ref(null);
    const gradeName = ref("");
    const gradesPicker = ref(false);
    const gradesFieldName = {
      text: "name"
    };
    const searchParams = reactive({
      grade: ""
    });
    const onSelectChangedGrade = data => {
      searchParams.pageIdx = 0;
      searchParams.grade = data.value;
      gradeName.value = data.name;
      gradesPicker.value = false;
      window.localStorage.setItem('exam', JSON.stringify(data));
      getPaperList();
    };
    const getPaperTypeList = async () => {
      const res = await PaperTypeList({
        user_id: userId.value,
        //用户id
        pid: pid //合作方id，先填空
      });
      console.log('getPaperTypeList', res);
      grades.value = res.data.data?.paper_type_list?.filter(item => {
        return [7, 8, 9].includes(item.paper_type_id) === false; //不显示 Hippo 的三个分类
      }).map(item => {
        return {
          name: item.paper_type_name,
          value: item.paper_type_id
        };
      });
    };
    const getPaperList = async () => {
      const res = await PaperList({
        user_id: userId.value,
        //用户id
        pid: pid,
        //合作方id，先填空
        token: token.value,
        sign: sign.value,
        paper_type_id: searchParams.grade //试卷类型id，传0则表示获取全部试卷
      });
      list.value = res.data.data.paper_list.map(item => {
        let obj = item.examinees.map(i => {
          return {
            ...i,
            showData: false
          };
        });
        return {
          ...item,
          examinees: obj,
          currentPage: 1
        };
      });
      console.log(list.value, 'adasdsdasdasdsa');
    };
    const handleChange = (item, e) => {
      console.log(item.paper_id, e);
      if (e) {
        window.open(`https://read2.bluebirdabc.com/exam/#/?user_id=${userId.value}&pid=${pid}&paper_id=${item.paper_id}&examinee_id=${e.examinee_id}`);
      } else {
        window.open(`https://read2.bluebirdabc.com/exam/#/?user_id=${userId.value}&pid=${pid}&paper_id=${item.paper_id}&examinee_id=0`);
      }
      // if (e instanceof Array) {
      //   if (e.length) {
      //     window.open(`https://read2.bluebirdabc.com/exam/#/?user_id=${userId.value}&pid=${pid}&paper_id=${item.paper_id}&examinee_id=${e[0]?.end_time ? 0 : e[0]?.examinee_id} `)
      //   } else {
      //     window.open(`https://read2.bluebirdabc.com/exam/#/?user_id=${userId.value}&pid=${pid}&paper_id=${item.paper_id}&examinee_id=0`)
      //   }
      // } else {
      //   window.open(`https://read2.bluebirdabc.com/exam/#/?user_id=${userId.value}&pid=${pid}&paper_id=${item.paper_id}&examinee_id=${e.examinee_id}`)
      // }
    };
    const getmousemove = item => {
      console.log(item);
      item.showData = true;
    };
    const getmouseout = item => {
      console.log(item);
      item.showData = false;
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_pagination = _resolveComponent("van-pagination");
      const _component_van_dialog = _resolveComponent("van-dialog");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
        href: 'https://read2.bluebirdabc.com/exam/#/a1-mover?user_id=' + userId.value + '&pid=' + _unref(pid) + '&token=' + token.value,
        target: "_blank"
      }, _hoisted_4, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleData.value.specialArticles, (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          href: "javascript: void(0)",
          key: index,
          onClick: $event => navTo(item.articleId)
        }, [item.coverImgUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.coverImgUrl
        }, null, 8, _hoisted_9)) : _createCommentVNode("", true), !item.coverImgUrl && index % 2 == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), !item.coverImgUrl && index % 2 != 0 ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("div", null, [_createElementVNode("span", null, [_createTextVNode("难度： "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.levelStar, (i, k) => {
          return _openBlock(), _createElementBlock("img", {
            src: _imports_3,
            key: k,
            style: {
              "width": "16px"
            }
          });
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - item.levelStar, (i, k) => {
          return _openBlock(), _createElementBlock("img", {
            src: _imports_4,
            key: k,
            style: {
              "width": "16px"
            }
          });
        }), 128))])])]), item.isUncompleted ? (_openBlock(), _createElementBlock("span", _hoisted_12, "待完成")) : _createCommentVNode("", true)])], 8, _hoisted_8);
      }), 128))])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
          name: 'search',
          query: {
            pid: _unref(pid)
          }
        }))
      }, "全部")]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleData.value.recommendArticles, (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          href: "javascript: void(0)",
          key: index,
          onClick: $event => navTo(item.articleId)
        }, [item.coverImgUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.coverImgUrl
        }, null, 8, _hoisted_18)) : _createCommentVNode("", true), !item.coverImgUrl && index === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_19)) : _createCommentVNode("", true), !item.coverImgUrl && index === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_20)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("div", null, [_createElementVNode("span", null, [_createTextVNode("难度： "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.levelStar, (i, k) => {
          return _openBlock(), _createElementBlock("img", {
            src: _imports_3,
            key: k,
            style: {
              "width": "16px"
            }
          });
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - item.levelStar, (i, k) => {
          return _openBlock(), _createElementBlock("img", {
            src: _imports_4,
            key: k,
            style: {
              "width": "16px"
            }
          });
        }), 128))])])]), item.isUncompleted ? (_openBlock(), _createElementBlock("span", _hoisted_21, "待完成")) : _createCommentVNode("", true)])], 8, _hoisted_17);
      }), 128))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
        href: 'https://read2.bluebirdabc.com/exam/#/hunan-home?user_id=' + userId.value + '&pid=' + _unref(pid) + '&token=' + token.value,
        target: "_blank"
      }, _hoisted_25, 8, _hoisted_23)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = $event => gradesPicker.value = true)
      }, [_createTextVNode(_toDisplayString(searchParams.grade ? gradeName.value : "试卷") + " ", 1), gradesPicker.value === true ? (_openBlock(), _createElementBlock("img", _hoisted_32)) : (_openBlock(), _createElementBlock("img", _hoisted_33))])])])]), _hoisted_34])]), _createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "items",
          key: item.paper_id
        }, [_createElementVNode("p", {
          onClick: $event => handleChange(item, item.doing_examinee)
        }, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.doing_examinee ? (_openBlock(), _createElementBlock("span", _hoisted_37, "(未完成)")) : _createCommentVNode("", true)], 8, _hoisted_36), item.examinees.length ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createTextVNode(" 答题记录: "), _createVNode(_component_van_pagination, {
          modelValue: item.currentPage,
          "onUpdate:modelValue": $event => item.currentPage = $event,
          "total-items": item.examinees.length,
          "show-page-size": 5,
          "items-per-page": 1
        }, {
          "prev-text": _withCtx(() => [_createVNode(_component_van_icon, {
            name: "arrow-left"
          })]),
          "next-text": _withCtx(() => [_createVNode(_component_van_icon, {
            name: "arrow"
          })]),
          page: _withCtx(({
            text
          }) => [_createElementVNode("div", {
            class: "pageText",
            onClick: $event => handleChange(item, item.examinees[text - 1]),
            onMouseenter: $event => getmousemove(item.examinees[text - 1]),
            onMouseleave: $event => getmouseout(item.examinees[text - 1])
          }, [_createElementVNode("span", null, _toDisplayString(text), 1), item.examinees[text - 1]?.showData && item.examinees[text - 1]?.end_time ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(item.examinees[text - 1]?.end_time), 1)) : _createCommentVNode("", true)], 40, _hoisted_39)]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "total-items"])])) : _createCommentVNode("", true)]);
      }), 128))])]), _createElementVNode("div", {
        class: "item",
        style: _normalizeStyle({
          marginBottom: isMobile.value ? '1.55rem' : '0',
          display: 'none'
        })
      }, _hoisted_43, 4)]), isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_44)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_45, [_createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_46, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_47, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_48, _createTextVNode(" 个人中心 ")])])]), _createVNode(_component_van_dialog, {
        show: show.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => show.value = $event),
        "show-cancel-button": false,
        "show-confirm-button": false,
        "close-on-click-overlay": true,
        style: {
          "width": "12.85rem",
          "height": "19rem",
          "border-top-left-radius": "0",
          "border-top-right-radius": "0"
        }
      }, {
        default: _withCtx(() => [_hoisted_49]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: gradesPicker.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => gradesPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: grades.value,
          "columns-field-names": gradesFieldName,
          onCancel: _cache[6] || (_cache[6] = $event => gradesPicker.value = false),
          onConfirm: onSelectChangedGrade
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"])], 2);
    };
  }
};